/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  SettleRealizedPnlRecordOptions,
  SettleRealizedPnlRecordStatus200,
  SettleRealizedPnlRecordStatus401,
  SettleRealizedPnlRecordStatus403,
  SettleRealizedPnlRecordStatus500,
} from '../types/SettleRealizedPnlRecord'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { settleRealizedPnlRecord } from '../clients/settleRealizedPnlRecord'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const settleRealizedPnlRecordMutationKey = () =>
  [{ url: '/v1/realized_pnl_settlements/:settlement_id' }] as const

export function settleRealizedPnlRecordMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = settleRealizedPnlRecordMutationKey()
  return mutationOptions<
    SettleRealizedPnlRecordStatus200,
    ResponseErrorConfig<
      | SettleRealizedPnlRecordStatus401
      | SettleRealizedPnlRecordStatus403
      | SettleRealizedPnlRecordStatus500
    >,
    SettleRealizedPnlRecordOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path }) => {
      return settleRealizedPnlRecord({ ...config, path, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Mark a realized P&L settlement as settled
 * {@link /v1/realized_pnl_settlements/:settlement_id}
 */
export function useSettleRealizedPnlRecord<TContext>(
  options: {
    mutation?: UseMutationOptions<
      SettleRealizedPnlRecordStatus200,
      ResponseErrorConfig<
        | SettleRealizedPnlRecordStatus401
        | SettleRealizedPnlRecordStatus403
        | SettleRealizedPnlRecordStatus500
      >,
      SettleRealizedPnlRecordOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? settleRealizedPnlRecordMutationKey()

  const baseOptions = settleRealizedPnlRecordMutationOptions(config) as UseMutationOptions<
    SettleRealizedPnlRecordStatus200,
    ResponseErrorConfig<
      | SettleRealizedPnlRecordStatus401
      | SettleRealizedPnlRecordStatus403
      | SettleRealizedPnlRecordStatus500
    >,
    SettleRealizedPnlRecordOptions,
    TContext
  >

  return useMutation<
    SettleRealizedPnlRecordStatus200,
    ResponseErrorConfig<
      | SettleRealizedPnlRecordStatus401
      | SettleRealizedPnlRecordStatus403
      | SettleRealizedPnlRecordStatus500
    >,
    SettleRealizedPnlRecordOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    SettleRealizedPnlRecordStatus200,
    ResponseErrorConfig<
      | SettleRealizedPnlRecordStatus401
      | SettleRealizedPnlRecordStatus403
      | SettleRealizedPnlRecordStatus500
    >,
    SettleRealizedPnlRecordOptions,
    TContext
  >
}
